<div class="section-disparo">
  <!-- <div>
    <span class="cabecalho-painel">Forma de Envio</span>
    <div class="divisor-roxo"></div>
  </div> -->
  <div class="painel-forma">

    <app-escolha-tipo-disparo
      [tipoDisparoEscolhido]="prepararTipoDisparo()"
      [listaDisabled]="{ Whatsapp: bloqueado, Email: bloqueado, sms: bloqueado }"
      (envioTipo)="receberTipoDisparo($event)">
    </app-escolha-tipo-disparo>

    <div class="corpo-forma">
      @switch (disparoAutomatico.tipoDisparo) {
        @case ('Whatsapp') {
          <div class="linha-selects">
            <app-select-one
              label="Template*"
              placeholder="Selecione"
              heightFormField="40px"
              [listaInput]="templates"
              [campo]="'name'"
              [habilitarBusca]="true"
              [desselecionar]="true"
              [carregandoInfo]="carregandoTemplates"
              [disabled]="!podeEditar"
              [itemSelecionado]="disparoAutomatico.template"
              (selecionarItem)="selecionarTemplate($event)">
            </app-select-one>
            <app-select-one
              label="Fluxo"
              placeholder="Selecione"
              heightFormField="40px"
              [listaInput]="fluxos"
              [campo]="'nome'"
              [habilitarBusca]="true"
              [desselecionar]="true"
              [disabled]="!podeEditar"
              [itemSelecionado]="disparoAutomatico.fluxo"
              (selecionarItem)="selecionarFluxo($event)">
            </app-select-one>
            <app-select-one
              label="Etapa"
              placeholder="Selecione"
              heightFormField="40px"
              [listaInput]="etapas"
              [campo]="'tituloComId'"
              [habilitarBusca]="true"
              [desselecionar]="true"
              [disabled]="!podeEditar || !disparoAutomatico.fluxo?.id"
              [itemSelecionado]="disparoAutomatico.etapa"
              (selecionarItem)="disparoAutomatico.etapa = $event">
            </app-select-one>
          </div>

          <div class="area-preview">
            @if (carregandoTemplates) {
              <div class="width-100 skeleton-preview-template skeleton"></div>
            } @else {
              <app-exibicao-template
                class="width-100"
                [tipo]="disparoAutomatico.tipoDisparo!"
                [listaContatos]="listaContatos"
                [aguardandoCargaInicialContatos]="aguardandoCargaInicialContatos"
                [origemContatos]="disparoAutomatico.origemContatos ?? 'EXCEL'"
                [template]="disparoAutomatico.template!"
                [variaveis]="variaveis"
                [colunasComplementares]="colunasComplementares"
                [disabled]="bloqueado"
                (variaveisCriadas)="receberVariaveis($event)">
              </app-exibicao-template>
            }
          </div>
        }

        @case ('sms') {
          <div class="linha-selects linha-sms">
            <app-select-one
              label="Template de SMS*"
              placeholder="Selecione"
              heightFormField="40px"
              [listaInput]="templates"
              [campo]="'name'"
              [habilitarBusca]="true"
              [desselecionar]="true"
              [carregandoInfo]="carregandoTemplates"
              [disabled]="!podeEditar"
              [itemSelecionado]="disparoAutomatico.template"
              (selecionarItem)="selecionarTemplate($event)">
            </app-select-one>
          </div>

          <div class="area-preview">
            @if (carregandoTemplates) {
              <div class="width-100 skeleton-preview-template skeleton"></div>
            } @else {
              <app-exibicao-template
                class="width-100"
                [tipo]="disparoAutomatico.tipoDisparo!"
                [listaContatos]="listaContatos"
                [aguardandoCargaInicialContatos]="aguardandoCargaInicialContatos"
                [origemContatos]="disparoAutomatico.origemContatos ?? 'EXCEL'"
                [template]="disparoAutomatico.template!"
                [variaveis]="variaveis"
                [colunasComplementares]="colunasComplementares"
                [disabled]="bloqueado"
                (variaveisCriadas)="receberVariaveis($event)">
              </app-exibicao-template>
            }
          </div>
        }

        @case ('Email') {
          @if (possuiModeloEmail) {
            <div class="area-email-preview">
              <button type="button" class="email-expandir-trigger" (click)="abrirPreviewExpandido()" title="Expandir preview">
                <img src="./assets/icones/maximize.svg" alt="">
              </button>
              <button type="button" class="email-menu-trigger" [matMenuTriggerFor]="menuEmail"
                      [disabled]="!podeEditar" title="Opções do modelo">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menuEmail="matMenu" class="menu-opcoes-email">
                <button mat-menu-item (click)="editarModeloEmail()">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>
                <button mat-menu-item (click)="excluirModeloEmail()">
                  <mat-icon>delete</mat-icon>
                  <span>Excluir</span>
                </button>
              </mat-menu>

              <div class="email-preview-topo">
                <div class="email-remetente">
                  <span class="email-remetente-avatar" aria-hidden="true">
                    <mat-icon>person</mat-icon>
                  </span>
                  <div class="email-remetente-dados">
                    <strong [title]="disparoAutomatico.emailRemetente || 'Salve para buscar o remetente'">
                      {{ disparoAutomatico.emailRemetente || 'Salve para buscar o remetente' }}
                    </strong>
                    <span>para: Contatos Base</span>
                  </div>
                </div>
                <div class="email-assunto">
                  <span class="email-assunto-label">ASSUNTO</span>
                  <strong [title]="assuntoPreviewEmail || '—'">{{ assuntoPreviewEmail || '—' }}</strong>
                </div>
              </div>
              <div class="email-preview-corpo">
                <app-email-preview [html]="htmlPreviewEmail"></app-email-preview>
              </div>
              @if (variaveisEmail.length) {
                <span class="email-preview-nota">*Variáveis exibidas com dados do primeiro contato.</span>
              }
            </div>
          } @else {
            <div class="dropzone-email" [class.arrastando]="arrastandoArquivo"
                (dragover)="aoArrastarSobre($event)"
                (dragleave)="aoArrastarSair($event)"
                (drop)="aoSoltarArquivo($event)">
              <div class="acoes-email">
                <app-button-padrao
                  label="Criar Modelo"
                  width="240px"
                  backgroundColor="var(--primary)"
                  color="white"
                  (buttonClick)="criarModeloEmail()"></app-button-padrao>
                <app-button-padrao
                  label="Anexar modelo HTML"
                  width="240px"
                  backgroundColor="white"
                  color="var(--primary)"
                  borderColor="var(--primary)"
                  borderStyle="dashed"
                  borderWidth="1px"
                  (buttonClick)="anexarModeloHtml()"></app-button-padrao>
                <span class="dropzone-dica">ou arraste um arquivo .html aqui</span>
              </div>
              <input #htmlInput type="file" accept="text/html,.html,.htm" hidden
                  (change)="aoSelecionarArquivoHtml($event)" />
            </div>
          }
        }
      }
    </div>
  </div>
</div>
